import { render, staticRenderFns } from "./Sixty-five_percent.vue?vue&type=template&id=e4939fca&scoped=true"
import script from "./Sixty-five_percent.vue?vue&type=script&lang=js"
export * from "./Sixty-five_percent.vue?vue&type=script&lang=js"
import style0 from "./Sixty-five_percent.vue?vue&type=style&index=0&id=e4939fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4939fca",
  null
  
)

export default component.exports